import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, e) {
  return o(), l("svg", t, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 22c5.522 0 10-4.477 10-10S17.522 2 12 2 2 6.477 2 12s4.478 10 10 10m5.999-10.072c-.03.553-.502 1-1.053 1h-6a.937.937 0 0 1-.945-1c.03-.552.502-1 1.053-1h6c.552 0 .974.448.945 1m-8.732 4.807c.38.38 1.012.363 1.413-.038s.418-1.034.039-1.414L7.436 12l3.473-3.473c.4-.4.418-1.034.038-1.414s-1.013-.362-1.414.039L5.335 11.35c-.193.192-.305.45-.312.715a.95.95 0 0 0 .274.699z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const s = { render: n };
export {
  s as default,
  n as render
};
//# sourceMappingURL=ic_arrow_left_bg-BSNHXgPL.js.map
